
class MasterListViewController extends EntityListViewController
{
    workspaceDidChange(){
        super.workspaceDidChange();
        this.showNoItemSelected();
    }

    protected showNoItemSelected() {}
}